var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-outline-secondary mr-2",on:{"click":_vm.deleteAnswer}},[_vm._v("Delete Answer "+_vm._s(_vm.answerIndex + 1))])}
var staticRenderFns = []

export { render, staticRenderFns }